import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLanguage } from "@/i18n/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { useLocalizedRoute } from "@/hooks/useLocalizedRoute";
import { LAST_UPDATED } from "@/lib/legal";

const LegalNotice = () => {
  const { t, lang } = useLanguage();
  useLocalizedRoute();

  useSEO({
    title: { es: t("seo", "legalTitle"), en: t("seo", "legalTitle") },
    description: { es: t("seo", "legalDesc"), en: t("seo", "legalDesc") },
    path: lang === "es" ? "/aviso-legal" : "/en/legal-notice",
    pathEs: "/aviso-legal",
    pathEn: "/en/legal-notice",

  });

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pt-6 pb-20">
        <section className="container max-w-3xl">
          {lang === "es" ? (
            <article className="prose prose-lg max-w-none text-foreground">
              <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">{LAST_UPDATED.es}</p>
              <h1 className="font-display text-4xl font-bold mb-8">Aviso Legal</h1>


              <h2>1. Datos identificativos</h2>
              <p>
                El sitio web <strong>retaillemon.com</strong> es operado por <strong>WP Media LLC</strong>,
                sociedad constituida en el estado de Delaware, Estados Unidos. La marca comercial bajo la que
                opera es <strong>Retail Lemon</strong>.
              </p>
              <ul>
                <li><strong>Razón social:</strong> WP Media LLC</li>
                <li><strong>Domicilio social:</strong> 8 The Green, Suite A, Dover, DE 19901, Estados Unidos</li>
                <li><strong>Nombre comercial:</strong> Retail Lemon</li>
                <li><strong>Email de contacto:</strong> hola@retaillemon.com</li>
                <li><strong>Sitio web:</strong> retaillemon.com</li>
              </ul>
              <p>
                <strong>Facturación y fiscalidad:</strong> Los servicios digitales prestados a través de
                retaillemon.com se facturan desde Estados Unidos por WP Media LLC, sin impuestos locales del país del
                cliente. Cada cliente es responsable de cumplir con sus propias obligaciones fiscales locales
                (autoliquidación, importación de servicios o el mecanismo equivalente en su jurisdicción). En la Unión
                Europea, los clientes profesionales aplican, cuando proceda, la inversión del sujeto pasivo.
              </p>

              <h2>2. Objeto del sitio web</h2>
              <p>
                Retail Lemon es una plataforma digital B2B para negocios retail y comercios de proximidad: panel de
                control, agente de inteligencia artificial, mentoría senior, hoja de ruta y herramientas de gestión y
                análisis para el día a día operativo y el crecimiento. Este sitio informa sobre esos servicios y
                facilita el contacto con empresas y profesionales interesados.
              </p>


              <h2>3. Propiedad intelectual e industrial</h2>
              <p>
                Todos los contenidos del sitio web, incluyendo textos, imágenes, diseño gráfico, código fuente, logos,
                marcas y demás elementos, son propiedad de Retail Lemon o de sus legítimos titulares y están protegidos
                por las normas nacionales e internacionales de propiedad intelectual e industrial.
              </p>
              <p>
                Queda prohibida su reproducción, distribución, comunicación pública o transformación, total o parcial,
                sin la autorización expresa y por escrito de Retail Lemon.
              </p>

              <h2>4. Condiciones de uso</h2>
              <p>
                El usuario se compromete a hacer un uso adecuado de los contenidos y servicios ofrecidos a través de
                este sitio web, absteniéndose de emplearlos para actividades ilícitas o contrarias a la buena fe.
              </p>

              <h2>5. Limitación de responsabilidad</h2>
              <p>
                Retail Lemon no se hace responsable de los posibles daños o perjuicios derivados de interferencias,
                omisiones, interrupciones, virus informáticos, averías telefónicas o desconexiones en el funcionamiento
                del sistema electrónico, así como de daños causados por terceros mediante intromisiones ilegítimas fuera
                de su control.
              </p>

              <h2>6. Enlaces a terceros</h2>
              <p>
                Este sitio web puede contener enlaces a páginas de terceros. Retail Lemon no asume responsabilidad
                alguna por el contenido, la política de privacidad o las prácticas de dichos sitios.
              </p>

              <h2>7. Naturaleza B2B e internacional</h2>
              <p>
                Retail Lemon es un servicio digital <strong>Business to Business (B2B)</strong> prestado en remoto desde
                Estados Unidos a empresas y profesionales de cualquier país, con clientes en América, Europa y otros
                mercados. La Compañía no dispone de establecimiento permanente en el país del cliente.
              </p>


              <h2>8. Contenidos informativos e inteligencia artificial</h2>
              <p>
                Los contenidos del sitio y de la plataforma tienen carácter formativo y orientativo. No constituyen
                asesoramiento legal, fiscal, contable, laboral, financiero ni de inversión. Determinadas funcionalidades
                se generan mediante inteligencia artificial y <strong>pueden contener errores o información
                desactualizada</strong>: deben verificarse antes de tomar decisiones y no vinculan a la Compañía.
              </p>
              <p>
                La información sobre ayudas y subvenciones tiene carácter meramente informativo y debe verificarse
                siempre en las fuentes oficiales.
              </p>


              <h2>9. Legislación aplicable y jurisdicción</h2>
              <p>
                Este aviso legal, así como el acceso y uso del sitio web, se rigen <strong>exclusivamente por las leyes
                del Estado de Delaware, Estados Unidos de América</strong>. Cualquier controversia se resolverá mediante
                <strong> arbitraje vinculante</strong> con sede en Delaware, conforme a lo previsto en las{" "}
                <a href="/condiciones-contratacion" className="text-foreground">Condiciones de Contratación</a>.
              </p>



              
            </article>
          ) : (
            <article className="prose prose-lg max-w-none text-foreground">
              <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">{LAST_UPDATED.en}</p>
              <h1 className="font-display text-4xl font-bold mb-8">Legal Notice</h1>

              <h2>1. Identification</h2>
              <p>
                The website <strong>retaillemon.com</strong> is operated by <strong>WP Media LLC</strong>,
                a company incorporated in the state of Delaware, United States. It trades under the brand
                name <strong>Retail Lemon</strong>.
              </p>
              <ul>
                <li><strong>Legal name:</strong> WP Media LLC</li>
                <li><strong>Registered address:</strong> 8 The Green, Suite A, Dover, DE 19901, United States</li>
                <li><strong>Trade name:</strong> Retail Lemon</li>
                <li><strong>Contact email:</strong> hola@retaillemon.com</li>
                <li><strong>Website:</strong> retaillemon.com</li>
              </ul>
              <p>
                <strong>Invoicing and taxes:</strong> Digital services delivered through retaillemon.com are invoiced
                from the United States by WP Media LLC, without local taxes of the client's country. Each client is
                responsible for its own local tax obligations (self-assessment, import of services or the equivalent
                mechanism in its jurisdiction). In the European Union, business customers apply the reverse charge where
                applicable.
              </p>

              <h2>2. Purpose</h2>
              <p>
                Retail Lemon is a B2B digital platform for retail businesses and neighbourhood stores: a control panel,
                the Retail AI Agent, senior mentoring, a roadmap and management and analysis tools for day-to-day operations and
                growth. This website provides information about those services and facilitates contact with interested
                companies and professionals.
              </p>


              <h2>3. Intellectual and industrial property</h2>
              <p>
                All content on this website, including text, images, graphic design, source code, logos, trademarks and
                other elements, is the property of Retail Lemon or its legitimate owners and is protected by national
                and international intellectual and industrial property regulations.
              </p>
              <p>
                Reproduction, distribution, public communication or transformation, in whole or in part, is prohibited
                without the express written authorization of Retail Lemon.
              </p>

              <h2>4. Terms of use</h2>
              <p>
                Users agree to make appropriate use of the content and services offered through this website, refraining
                from using them for unlawful activities or activities contrary to good faith.
              </p>

              <h2>5. Limitation of liability</h2>
              <p>
                Retail Lemon shall not be liable for any damages arising from interference, omissions, interruptions,
                computer viruses, telephone breakdowns or disconnections in the operation of the electronic system, or
                for damages caused by third parties through illegitimate intrusions beyond its control.
              </p>

              <h2>6. Third-party links</h2>
              <p>
                This website may contain links to third-party sites. Retail Lemon assumes no responsibility for the
                content, privacy policies or practices of such sites.
              </p>

              <h2>7. B2B and international nature</h2>
              <p>
                Retail Lemon is a <strong>Business to Business (B2B)</strong> digital service delivered remotely from the
                United States to companies and professionals in any country, with clients across the Americas, Europe and
                other markets. The Company has no permanent establishment in the client's country.
              </p>


              <h2>8. Informational content and artificial intelligence</h2>
              <p>
                Content on this site and platform is educational and indicative. It does not constitute legal, tax,
                accounting, employment, financial or investment advice. Certain features are generated using artificial
                intelligence and <strong>may contain errors or outdated information</strong>: verify before making
                decisions; such output does not bind the Company.
              </p>
              <p>
                Information about grants and subsidies is informational only. Always verify it in the official sources.
              </p>


              <h2>9. Applicable law and jurisdiction</h2>
              <p>
                This legal notice and any access to or use of the website are governed <strong>exclusively by the laws of
                the State of Delaware, United States of America</strong>. Any dispute shall be resolved through{" "}
                <strong>binding arbitration</strong> seated in Delaware, as set out in the{" "}
                <a href="/en/terms-of-service" className="text-foreground">Terms of Service</a>.
              </p>



              
            </article>
          )}
        </section>
      </main>
      <Footer />
    </>
  );
};

export default LegalNotice;
